import { tryToGetBrandColorRefByHEX } from 'modules/BrandDefinition';
import { createLexicalTextEditor } from 'modules/Lexical/editors';
import { DefaultCustomStyle } from 'const';
import * as Models from 'models';
import * as fontUtils from '../../Plugins/FontPlugin/utils';
import { $matchFontColor, $matchFontNameAndCharacterStyle } from '../../Plugins/FontPlugin/utils';
/**
 * Resets nonexistent brand style and saves applied styles everywhere if it's possible
 * NOTE: for now, always resets font family and font style to default value
 */
export const resetBrandStyleOnComponent = (
  textComponent: Models.TextComponent,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): Models.TextComponent => {
  const { lexicalState } = textComponent;

  if (!lexicalState) {
    return textComponent;
  }

  const defaultFontColorStyle = tryToGetBrandColorRefByHEX(colors, DefaultCustomStyle.FONT_COLOR);

  const editor = createLexicalTextEditor(lexicalState);
  editor.update(() => {
    // FONT SIZE
    fontUtils.$applyFontSizeToAllNodes(DefaultCustomStyle.FONT_SIZE);

    // FONT COLOR
    $matchFontColor(colors, defaultFontColorStyle);

    // FONT NAME and CHARACTER STYLE
    $matchFontNameAndCharacterStyle(
      fonts,
      DefaultCustomStyle.FONT_FAMILY,
      undefined,
    );
  }, { discrete: true });

  return { ...textComponent, lexicalState: JSON.stringify(editor.getEditorState()) };
};
